﻿/// <reference path="../../Scripts/TypeScript/angularjs/angular.d.ts"/>
/// <reference path="../../Decorators.ts" />

namespace Umbrella.Search.Vendors {
    angular.module('Search').config([
        '$stateProvider',
        $stateProvider => {
            $stateProvider.state('search.vendors', {
                reloadOnSearch: true,
                url: '/leveranciers?query',
                data: {
                    pageTitle: 'Leveranciers',
                    authorize: ps => ps.customerCard
                },
                views: {
                    'center@search': {
                        templateUrl: '/Search/_Vendors/VendorOverview.html',
                        controller: 'VendorOverviewController'
                    }
                }
            });
        }
    ]);
}
